<template lang="html">
    <div>
        <div class="w-full vx-col mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Add New User</h4>
                    </div>
                    <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="submitForm" icon="save">Save</vs-button>
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Username*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="user.username" />
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Email*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="user.email" />
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Password*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="user.password" type="password"/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                User Group*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.user_group_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, usergroup)"
                                >
                                    <vs-select-item v-for="(item, index) in usergroup.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                User Type*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.user_type"
                                    width="100%"
                                    autocomplete
                                >
                                    <vs-select-item value="Regular" text="Regular"/>
                                    <vs-select-item value="Client" text="Client"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Status*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.status"
                                    width="100%"
                                    autocomplete
                                >
                                    <vs-select-item value="1" text="Active"/>
                                    <vs-select-item value="0" text="Inactive"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Client*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.client_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, client)"
                                    :disabled="user.user_type == 'Regular'"
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Vehicle
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.vehicle_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, vehicle)"
                                >
                                    <vs-select-item v-for="(item, index) in vehicle.data" :key="index" :value="item.id" :text="item.vehicle_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-divider border-style="solid">User Access</vs-divider>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Client Access
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.client_access"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchMultiple($event, client)"
                                    multiple
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Warehouse Access
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.warehouse_access"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchMultiple($event, warehouse)"
                                    multiple
                                >
                                    <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-divider border-style="solid">User Defaults</vs-divider>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Client Default
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.client_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, client)"
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Origin ID
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.origin_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, customer)"
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Destination ID
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.destination_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, customer)"
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Supplier ID
                            </div>
                            <div class="w-2/3 vx-col">
                                 <vs-select
                                    class="selectExample"
                                    v-model="defaults.supplier_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, customer)"
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Warehouse Default
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.warehouse_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, warehouse)"
                                >
                                    <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Inbound Type
                            </div>
                            <div class="w-2/3 vx-col">
                                 <vs-select
                                    class="selectExample"
                                    v-model="defaults.inbound_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, order_type)"
                                >
                                    <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Outbound Type
                            </div>
                            <div class="w-2/3 vx-col">
                                 <vs-select
                                    class="selectExample"
                                    v-model="defaults.outbound_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, order_type)"
                                >
                                    <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Base UoM
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.base_uom_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, uom)"
                                >
                                    <vs-select-item v-for="(item, index) in uom.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Part UoM
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.part_uom_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, uom)"
                                >
                                    <vs-select-item v-for="(item, index) in uom.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Unit Weight
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.unit_weight_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, unit_weight)"
                                >
                                    <vs-select-item v-for="(item, index) in unit_weight.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Section
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.section_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, section)"
                                >
                                    <vs-select-item v-for="(item, index) in section.data" :key="index" :value="item.id" :text="item.section_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Currency
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.currency_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, currency)"
                                >
                                    <vs-select-item v-for="(item, index) in currency.data" :key="index" :value="item.id" :text="item.currency_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Stock Type
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.stock_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, stock_type)"
                                >
                                    <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row" >
                            <div class="w-1/3 vx-col">
                                Product Category
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.product_categories_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, product_category)"
                                >
                                    <vs-select-item
                                    v-for="(item, index) in product_category.data"
                                    :key="index" :value="item.id" :text="item.name" />
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Unit Volume
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="defaults.unit_volume_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, unit_volume)"
                                >
                                    <vs-select-item class="" v-for="(item, index) in unit_volume.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-divider border-style="solid">Auto Generate Report</vs-divider>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Send Report By Email
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="user.report_by_email"
                                    width="100%"
                                    autocomplete
                                >
                                    <vs-select-item value="1" text="Yes"/>
                                    <vs-select-item value="0" text="No"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Password Access
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="user.report_password" type="password"/>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import { AgGridVue } from "ag-grid-vue";

	export default {
		components:{
            vSelect,
            AgGridVue
		},
		data(){
			return {
                isLoading: false,
                user: {
                    username: '',
                    email: '',
                    password: '',
                    report_password: '',
                    user_group_id: null,
                    vehicle_id: null,
                    client_id: null,
                    user_type: 'Regular',
                    status: 1,
                    report_by_email: 0
                },
                defaults: {
                    client_access: [],
                    warehouse_access: [],
                    client_id: null,
                    warehouse_id: null,
                    origin_id: null,
                    destination_id: null,
                    supplier_id: null,
                    inbound_type_id: null,
                    outbound_type_id: null,
                    section_id: null,
                    base_uom_id: null,
                    part_uom_id: null,
                    unit_weight_id: null,
                    unit_volume_id: null,
                    currency_id: null,
                    stock_type_id: null,
                    product_categories_id: null
                },
                usergroup: {
                    data: [],
                    loading: false,
                    endpoint: 'rolemanagement/usergroup',
                    objectKey: 'name'
                },
                customer: {
                    data: [],
                    loading: false,
                    endpoint: 'master/customers',
                    objectKey: 'name'
                },
                currency: {
                    data: [],
                    loading: false,
                    endpoint: 'master/currency',
                    objectKey: 'currency_code'
                },
                client: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients',
                    objectKey: 'name'
                },
                order_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/ordertypes',
                    objectKey: 'order_type'
                },
                uom: {
                    data: [],
                    loading: false,
                    endpoint: 'master/uom',
                    objectKey: 'name'
                },
                unit_weight: {
                    data: [],
                    loading: false,
                    endpoint: 'master/uow',
                    objectKey: 'name'
                },
                section: {
                    data: [],
                    loading: false,
                    endpoint: 'master/sections',
                    objectKey: 'section_code'
                },
                stock_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/stocktypes',
                    objectKey: 'name'
                },
                product_category: {
                    data: [],
                    loading: false,
                    endpoint: 'master/productcategories',
                    objectKey: 'name'
                },
                unit_volume: {
                    data: [],
                    loading: false,
                    endpoint: 'master/uov',
                    objectKey: 'name'
                },
                warehouse: {
                    data: [],
                    loading: false,
                    endpoint: 'master/warehouses',
                    objectKey: 'warehouses_code'
                },
                vehicle: {
                    data: [],
                    loading: false,
                    endpoint: 'master/vehicle',
                    objectKey: 'vehicle_code'
                },
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            fetchData() {
                this.isLoading = true
                Promise.all([
                    this.$http.post('rolemanagement/usergroup'),
                    this.$http.post('master/clients'),
                    this.$http.post('master/warehouses'),
                    this.$http.post('master/customers'),
                    this.$http.post('master/ordertypes'),
                    this.$http.post('master/sections'),
                    this.$http.post('master/uom'),
                    this.$http.post('master/uow'),
                    this.$http.post('master/uov'),
                    this.$http.post('master/productcategories'),
                    this.$http.post('master/stocktypes'),
                    this.$http.post('master/currency'),
                    this.$http.post('master/vehicle')
                ])
                .then(this.$http.spread((usergroups, clients, warehouses, customers, ordertypes, sections, uoms, uows, uovs, productcategories, stocktypes, currency, vehicle) => {
                    this.usergroup.data = usergroups.data.data;
                    this.warehouse.data = warehouses.data.data;
                    this.client.data = clients.data.data;
                    this.customer.data = customers.data.data;
                    this.order_type.data = ordertypes.data.data;
                    this.uom.data = uoms.data.data;
                    this.unit_weight.data = uows.data.data;
                    this.section.data = sections.data.data;
                    this.stock_type.data = stocktypes.data.data;
                    this.unit_volume.data = uovs.data.data;
                    this.product_category.data = productcategories.data.data;
                    this.currency.data = currency.data;
                    this.vehicle.data = vehicle.data.data;

                    this.isLoading = false;
                }))
                .catch(error => this.handleError(error))
            },
            submitForm() {
                this.isLoading = true;
                this.$http.post("rolemanagement/users/store", {
                    user: this.user,
                    defaults: this.defaults
                })
                .then(res => {
                    this.isLoading = false;
                    const message = res.data.message ? res.data.message : 'Success.'
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: message
                    });

                    this.$router.push({
                        name: "user-view",
                        params: {
                            id: res.data.id
                        }
                    });
                })
                .catch(error => this.handleError(error));
            },
            back() {
                this.$vs.dialog({
                    color: 'warning',
                    title: 'Leave Page',
                    text: 'Changes you made may not be saved',
                    acceptText: 'Leave Page',
                    accept: () => this.$router.push({
                        name: 'user'
                    }),
                })
            },
            searchMultiple(event, parent) {
                const arr = event.target.value.split(',')
                const last = this.$_.last(arr)

                const query = {
                    [parent.objectKey]: last
                };

                this.$http.post(parent.endpoint, query).then(res => {
                    parent.loading = false;
                    res.data.data.map(d => {
                        if (parent.data.findIndex(p => p.id === d.id) === -1) {
                            parent.data.push(d);
                        }
                    });
                });
            }
        },
        mounted(){
            this.fetchData()
        },
	}
</script>

<style>

</style>
